export default "__VITE_ASSET__09m75go1__"